/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function removeTabindex() {
  document.querySelectorAll('.product-item__bg__slider[tabindex]').forEach(el => {
    el.removeAttribute('tabindex');
  });
}

// run initially
document.addEventListener("DOMContentLoaded", function () {
  removeTabindex();

  // Flickity / Shopify lazy DOM fix
  setTimeout(removeTabindex, 1000);
  setTimeout(removeTabindex, 3000);
});

// watch dynamic changes
const observer = new MutationObserver(() => {
  removeTabindex();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
